<template>
  <div
    v-if="journals.length > 0"
  >
    <h2 class="pa-3">
      {{ title }}
    </h2>
    <slot />
    <div v-for="(journal, index) in journals" :key="journal.id">
      <JournalSection
        :id="`journal-card-iterator-${index + startingIndex}`"
        :journal="journal"
      />
    </div>
  </div>
</template>
<script>
import JournalSection from './JournalSection';

export default {
  name: 'JournalSectionList',
  props: {
    title: {
      type: String,
      required: true,
    },
    journals: {
      type: Array,
      required: true,
    },
    startingIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    JournalSection,
  },
};
</script>
<style scoped>
</style>
